import { LISTING_CATEGORY } from './actionType'

export const categoryList = (data) => {
  return {
    type: LISTING_CATEGORY,
    payload: data,
  }
}
